import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import Pagination from "../Pagination";
// import Loader from "../../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import API from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Loader } from "../../../constants/whitelabelEnv";
import { domain } from "../../../constants/Branding";
import { useTranslation } from "../../../hooks/useTranslation";
import { connect } from "react-redux";
import { RootState } from "../../../models/RootState";

type WagerListProps = {
    dynamicTextColors?: any;
};

const WagerList: React.FC<WagerListProps> = ({ dynamicTextColors }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [games, setGames] = useState<any>([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const navigate = useNavigate();
    const [count, setCount] = useState<any>(0);
    const [page1, setPage1] = useState(1);
    const isFirstRender = useRef(true);

    // Get dynamic text color classes from Redux
    const pageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
    const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';
    const tableHeaderTextColorClass = dynamicTextColors?.tableHeaderTextColorClass || '';
    const tableTextColorClass = dynamicTextColors?.tableTextColorClass || '';

    const getBetList = async () => {
        if (isFirstRender.current) {
            setLoading(true);
            isFirstRender.current = false;
        }

        let response;
        try {
            response = await API.post(`/webapp/get-casino-wager-games`, {

                is_wager: false,
                page_no: page1,
                page_size: rowsPerPage

            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            toast.error(response.data?.error_description)
            navigate("/home");
        }

        if (response && response.data?.games) {
            setGames(response?.data?.games);
            if (page1 === 0 || page1 === 1) {
                setCount(response?.data?.count);
            }
        }
        setLoading(false);
    };



    const handleBackClick = () => {
        navigate(-1);
    };

    useEffect(() => {
        getBetList();
    }, [])






    return (
        <>
            <>
                <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] bet-list">
                    {
                        loading ? (
                            <div className="home-loading">
                                <img src={Loader(domain)} style={{ height: '10rem' }} />
                            </div>
                        ) : (
                            <>
                                <header className={`flex gap-3 items-center self-start text-base font-medium text-center mb-[0.5rem] w-full ${pageTextColorClass} ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: pageTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                                <div>
                                <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                                    onClick={() => handleBackClick()}
                                >
                                    <ArrowBackIcon
                                        className={`aspect-square w-[18px] ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        style={{ 
                                            width: '20px', 
                                            height: '20px',
                                            color: inputBoxTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF'
                                        }}
                                    />
                                </div>
                                </div>
                                <h2 className={`self-stretch my-auto ${pageTextColorClass} ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: pageTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>{t("bets.gamesList")}</h2>
                                </header>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full border-collapse user-table border-x mt-1">
                                        <thead>
                                            <tr>
                                                <th className={`px-4 py-2 text-left border-b border-t ${tableHeaderTextColorClass} ${tableHeaderTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: tableHeaderTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>{t("bets.game")}</th>
                                                <th className={`px-4 py-2 text-left border-b border-t ${tableHeaderTextColorClass} ${tableHeaderTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: tableHeaderTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>{t("bets.provider")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {games.map((row: any, index: number) => (
                                                <tr key={index} className={`border-b ${tableTextColorClass} ${tableTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                                >

                                                    <td className={`p-2 ${tableTextColorClass} ${tableTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: tableTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>{row?.game_name}</td>
                                                    <td className={`p-2 ${tableTextColorClass} ${tableTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: tableTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                                                        {row?.provider_name}
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                                <Pagination currentPage={page1} setCurrentPage={setPage1} setRowsPerPage={setRowsPerPage} rowsPerPage={rowsPerPage} eventsCount={count} callBackFunc={getBetList} dynamicTextColors={dynamicTextColors} />
                            </>
                        )
                    }
                </div>
            </>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        dynamicTextColors: state.userDetails?.dynamicTextColors,
    };
};

export default connect(mapStateToProps)(WagerList);
